import React, { FunctionComponent, useEffect } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Routes } from '../../../../common/enums/Routes';
import { getBackgroundURL } from '../../../../common/helpers/backgroundHelper';
import { IBindingCallback1 } from '../../../../common/models/callback';
import { IAppState } from '../../../../common/models/store/IAppState';
import CandidateFormSidebar from '../../../../components/CandidateFormSidebar';
import Icon from '../../../../components/Icon';
import RegularButton from '../../../../components/RegularButton';
import { WorkspaceState } from '../../../../reducers/workspace';
import { setWorkspaceColorsRoutine } from '../../../../routines/workspace';
import ReferenceRoleForm from '../../../../components/ReferenceRoleForm';
import RefFormSidebar from '../../../../components/RefFormSidebar';
import { RefFormPages } from '../../../CandidateForm/containers/CandidateForm/utils';
import styles from './styles.module.scss';
import { refRequestData } from './utils';

interface IProps extends RouteComponentProps {
  workspace: WorkspaceState;
  setWorkspaceColors: IBindingCallback1<boolean>;
}

const CandidateFormPane: FunctionComponent<IProps> = ({
  history,
  workspace: { settings, lightLogo },
  setWorkspaceColors
}) => {
  useEffect(() => {
    setWorkspaceColors(true);
    return () => setWorkspaceColors(false);
  }, []);
  const circleColor = settings?.['--circle-color'];

  return (
    <div className={`cf-bd ${styles.previewContainer}`} style={{ backgroundImage: getBackgroundURL(circleColor) }}>
      <CandidateFormSidebar circleColor={circleColor} logo={lightLogo as string}>
        <RefFormSidebar {...refRequestData} currentPage={RefFormPages.ReferenceRole} />
      </CandidateFormSidebar>
      <div className={styles.body}>
        <ReferenceRoleForm
          references={refRequestData.references}
          counters={refRequestData.refCounters}
          currentReference={refRequestData.currentReference}
          disabledTypes={[]}
          onContinue={() => null}
          onGoBack={() => null}
        />
        <RegularButton
          textIntlId="candidateFormPane.goToSettings"
          defaultMessage="Go to settings"
          icon={<Icon icon="arrowLeft" />}
          iconPosition="left"
          onClick={() => history.replace(Routes.CandidateFormSettings)}
          variant="secondary"
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({ workspace }: IAppState) => ({ workspace });

const mapDispatchToProps = ({ setWorkspaceColors: setWorkspaceColorsRoutine });

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CandidateFormPane));
